import { Helmet } from "react-helmet"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import "react-accessible-accordion/dist/fancy-example.css"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

export default function AboutUs() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About us FGH – Your One-Stop Gaming Website</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Learn about FGH Casino – Fun Gaming Hub, offering live blackjack, slot games, and sports betting with local wallets support. Trusted, secure & for players 21+.
"
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      <div className="main-body-content main-container-global-adjusted-padding tnc-page">
        <h1 className="fgh-h1-style">
          About us FGH – Your One-Stop Gaming Website
        </h1>

        <Accordion preExpanded={["a"]}>
          <AccordionItem uuid="a">
            <AccordionItemHeading>
              <AccordionItemButton>About Us</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                FGH, or Fun Gaming Hub, offers the most comprehensive selection
                of cutting-edge games from well-known providers in a secure and
                regulated environment. FGH offers a wide variety of gaming
                products, including Online Slots Casinos, Live Dealers, Sports
                Books, and Fishing Games. We want to provide you with the best
                game providers possible, so we will keep adding new ones.
              </p>
              <p>
                The SLOTS category currently has fourteen game providers,
                including CQ9 slots, BOOONGO slots, YGGDrasil slots, JILI slots,
                and many others. The Live Casino dealer category for table games
                has three providers: Evolution, AE Sexy Gaming, and SA Gaming.
                ASC and Pinnacle are the only two in the sportsbook category,
                and the latter is home to several well-known Esports titles. The
                best part is that you can play the most popular games here, such
                as LOTTO, Bingo, and fishing games! In addition to providing the
                best gaming experience possible, Fun Gaming Hub Website has gone
                above and beyond to ensure that each of our games has earned TST
                Game International Certifications. This way, you can play with
                assurance in a controlled and safe setting.
              </p>
              <p>
                We are dedicated to providing our players with an unrivaled
                selection of high-quality entertainment solutions. The ultimate
                gaming experience is created by combining innovation, ambiance,
                cutting-edge technology, and round-the-clock service at your
                fingertips.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                FGH App and Payment Method
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                You can also have fun while getting the best possible experience
                by using the FGH Mobile App. You can use your FGH app to play
                your favorite FGH games from anywhere and anytime. Deposits and
                withdrawals such as bank transfers, gcash wallet, and
                cryptocurrency using TRC20-USDT, USDC, ERC20-USDT, USDC, BTC,
                and ETH, are all available, ensuring that your winnings are
                transferred and that you receive your credits.
              </p>
              <p>
                Our platform is the most popular among online casino philippines
                gcash users. Online casino Philippines gcash websites, like this
                one in FGH, provide users with a fantastic opportunity for real
                money earning games Philippines slots gcash players and others.
                As a leading integrated gaming platform of online casino games,
                we appreciate your choice to support Fun Gaming Hub Filipino
                casino games. We personally hope you enjoy our FGH website, and
                if you need help, please contact our customer support team,
                which is available around the clock and will do everything
                possible to assist you.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Contact Us</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                We provide a live chat option that is available 24 hours a day,
                seven days a week. This will open a chat window with one of our
                support consultants.
              </p>
              <p>
                Following that, you may contact us using the methods listed
                below:
              </p>

              <ul className="fgh-accordion-list fgh-contact-list">
                <li>
                  Mobile: <a href="tel:+63286263222">+63-2-8-6263222</a>
                </li>
                <li>
                  Telegram:{" "}
                  <a href="https://t.me/fungaminghub">@FUNGAMINGHUB</a>
                </li>
                <li>
                  Email:{" "}
                  <a href="mailto:support@fgh.fun" rel="noopener noreferrer">
                    support@fgh.fun
                  </a>
                </li>
                <li>
                  You can also check our FAQ section where you’ll find the
                  answers to the most commonly asked questions.
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    </>
  )
}
